import { X } from 'react-feather';
import { StandardModalContent } from './ModalStackContext';
import styles from './StandardModalHeader.module.css';

type StandardModalHeaderProps = {
  title?: StandardModalContent['title'];
  showCloseX?: StandardModalContent['showCloseX'];
  onCancel?: StandardModalContent['onCancel'];
};

/** Standard title header for a modal */
export default function StandardModalHeader(
  props: StandardModalHeaderProps,
): React.ReactElement {
  const { title, showCloseX, onCancel } = props;

  if (!title && !showCloseX) return <></>;

  return (
    <h3 className={styles.title}>
      <span>{title}</span>
      {showCloseX ? (
        <span onClick={onCancel} className={styles.x}>
          <X />
        </span>
      ) : null}
    </h3>
  );
}
